import { all } from 'redux-saga/effects';

import { applicationSaga } from './app';
import { authSaga } from './auth';
import { userProfileSaga } from './userProfile';
import { datasetsSaga } from './datasets';
import { artsSaga } from './arts';
import { navigationSaga } from './navigation';
import { statisticsSaga } from './statistics';

import { handleErrors } from 'utils';

const handleErrorsWithRestart = (saga) =>
  handleErrors({
    anyError: function* () {
      yield all([handleErrorsWithRestart(saga)]);
    },
  })(saga)();

export const rootSaga = function* () {
  yield all([
    handleErrorsWithRestart(applicationSaga),
    handleErrorsWithRestart(authSaga),
    handleErrorsWithRestart(userProfileSaga),
    handleErrorsWithRestart(datasetsSaga),
    handleErrorsWithRestart(artsSaga),
    handleErrorsWithRestart(navigationSaga),
    handleErrorsWithRestart(statisticsSaga),
  ]);
};
